import { RealmsModule } from './realms/realms.store';
import { AdminModule } from './admin/admin.store';
import { UserModule } from './user/user.store';
import { NewsModule } from './news/news.store';
import { SystemModule } from './system/system.store';
import { NavigationModule } from './navigation/navigation.store';
import { StatisticsModule } from './statistics/statistics.store';
import { ChatModule } from './chat/chat.store';
import { BugTrackerModule } from './bugtracker/bugtracker.store';

export default {
    RealmsModule,
    AdminModule,
    UserModule,
    NewsModule,
    SystemModule,
    NavigationModule,
    StatisticsModule,
    ChatModule,
    BugTrackerModule
};
